module.exports = __webpack_public_path__ + "static/gap3-b56d96406adf3a956576b2690eb6acf2.jpg";